import React, { useContext } from 'react';

import { opUpdatesContext } from './OperationalUpdatesStateProvider';
import { OpUpdatesCountry } from './OpUpdatesCountry';


export function OperationalUpdates() {
	const state = useContext(opUpdatesContext).state;
	const countries = state.countries;

	return (
		<>
			{countries.length ?
				countries.map(c => <OpUpdatesCountry key={c.pk} country={c}/>)
				: <p>No country has been added to this section.</p>
			}
		</>
	);
}